export default __webpack_public_path__ + "static/media/classify3.56f484b0.png";